import { Progress } from '@/components/ui/progress'

export interface CampaignOption {
  id: number
  name: string
  goal_cents?: number | null
  raised_cents?: number
  progress_percent?: number | null
}

export function CampaignContext({
  campaigns,
  campaignId,
}: {
  campaigns: CampaignOption[]
  campaignId: string
}) {
  const campaign = campaigns.find((option) => String(option.id) === campaignId)
  if (!campaign) return null
  const progress = Math.min(campaign.progress_percent ?? 0, 100)
  return (
    <section className="flex min-w-0 flex-col gap-4 rounded-md border border-border bg-card p-4">
      <div>
        <h2 className="text-body font-medium">{campaign.name}</h2>
        <p className="mt-1 text-body-sm text-muted-foreground">Support this campaign.</p>
      </div>
      {campaign.goal_cents ? (
        <div className="mt-auto space-y-2">
          <div className="flex justify-between text-caption text-muted-foreground">
            <span>${((campaign.raised_cents ?? 0) / 100).toFixed(2)} raised</span>
            <span>${(campaign.goal_cents / 100).toFixed(2)} goal</span>
          </div>
          <Progress value={progress} />
        </div>
      ) : (
        <p className="text-caption text-muted-foreground">Every gift helps.</p>
      )}
    </section>
  )
}
